var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectedDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.2,
    height: 20,
    viewBox: "0 0 15.2 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-ios-document",
    "data-name": "Icon ionic-ios-document",
    transform: "translate(-7.313 -3.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M21.552,8.89H26.1a.248.248,0,0,0,.25-.25h0a1.48,1.48,0,0,0-.535-1.145L22,4.315a1.606,1.606,0,0,0-1.03-.37h0a.369.369,0,0,0-.37.37V7.94A.95.95,0,0,0,21.552,8.89Z",
    transform: "translate(-3.839 -0.002)",
    fill: "#d3a34c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M15.463,7.938v-4H8.913a1.6,1.6,0,0,0-1.6,1.6v16.8a1.6,1.6,0,0,0,1.6,1.6h12a1.6,1.6,0,0,0,1.6-1.6V10.188h-4.8A2.253,2.253,0,0,1,15.463,7.938Z",
    fill: "#d3a34c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedDocumentIcon);
export default __webpack_public_path__ + "static/media/selected-document-icon.610bb568a633dcc53d6ca8c75ef5d32a.svg";
export { ForwardRef as ReactComponent };